module.exports = __webpack_public_path__ + "static/media/seminar_program_3.da08dca9.pdf";